import { Store } from '../../types'

export const cashFlowKeysSelector = (store: Store) => store.session.cashFlowSelectedKeys
